<template>
    <a-tabs v-model:activeKey="activeKey" :animated="false">
        <a-tab-pane key="1" :tab="'已发布（'+total+'）'">
            <div class="tab-blank" v-if="list.length===0">
                <a-empty />
            </div>
            <div class="list" v-else>
                <div class="essay-item" v-for="item in list" :key="item.agg_id">
                    <div class="delete" v-show="loginUserId==userId">
                        <a-button type="link" danger @click="deleteItem(item.agg_id)"  style="font-size:15px">删除</a-button>
                    </div>
                    <div class="title">
                        <router-link :to="{path:'/collection_detail',query:{id:item.agg_id}}" target="_blank" v-html="item.agg_name"></router-link>
                    </div>
                    <div class="summary" style="color:#666">{{item.summary}}</div>
                    <div class="count">
                        {{numWan(item.collectQua)}}人收藏 <a-divider type="vertical" /> {{numWan(item.artCount)}}篇论文
                    </div>
                </div>
                <div class="page">
                    <a-pagination :current="currentPage" :pageSize="10" show-quick-jumper :total="total" @change="getList" :hideOnSinglePage="true" />
                </div>
            </div>
        </a-tab-pane>
    </a-tabs>
</template>

<script>
import {defineComponent, onMounted, reactive, toRefs, computed, watch} from 'vue';
import { useRoute } from 'vue-router';
import Http from '../../until/http';
import { Modal } from "ant-design-vue";
import { getLocalItem, messageTips, numWan } from '../../until/tools';
export default defineComponent({
    setup() {

        const state = reactive({
            activeKey:'1',
            total:0,
            list:[],
            currentPage:1
        })

        const route = useRoute();
        const userId = computed(()=>{
            return parseInt(route.query.id);
        });

        const loginUserId = computed(()=>{
            return getLocalItem('userInfo')?parseInt(getLocalItem('userInfo').userId):null;
        })

        const keywords = computed(()=>{
            return route.query.keyword;
        })

        const getList = (page=1)=>{
            Http.getUserCollections({userId:userId.value,currentPage:page,keyword:keywords.value}).then(res=>{
                if(res) {
                    if(res.aggsList) {
                        Object.assign(state,{
                            list:res.aggsList,
                            total:res.page.allSize,
                            currentPage:page
                        })
                    }
                }
            })
        }

        watch(keywords,()=>{
            getList();
        })

        const deleteItem=(id)=>{
            Modal.confirm({
                title:'删除论文集',
                content:'您确定要删除这个论文集吗 ？删除后不可恢复 ，请您慎重考虑',
                centered:true,
                okText:'确认',
                cancelText:'取消',
                onOk() {
                    Http.deleteEssayCollection({aggId:id}).then(res=>{
                        if(res) {
                            if(res.success) {               
                                let allPage = Math.ceil((state.total-1)/10);
                                let page;
                                if(allPage<state.currentPage) {
                                    page = allPage;
                                } else {
                                    page = state.currentPage;
                                }
                                if(page<1) {
                                    page = 1;
                                }
                                messageTips(res.message,3);
                                getList(page);
                            } else {
                                messageTips(res.message,1);
                            }
                        }
                    })
                }
            })
        }

        onMounted(()=>{
            getList()
        })


        return {
            ...toRefs(state),
            numWan,
            getList,
            deleteItem,
            userId,
            loginUserId
        }
    }
})
</script>


<style lang="scss" scoped>
/deep/.ant-modal-confirm-body .ant-modal-confirm-title {
    margin-top: -10px;
    margin-left: -5px;
}
/deep/.ant-modal-confirm-body .ant-modal-confirm-content {
    margin-left: 13px;
}
</style>